import React, { useState, useRef, useEffect } from "react";
import { Editor } from '@tinymce/tinymce-react';

import "./uploadFeed.scss";
import {
  createFeed,
  createFeedMultiple,
  fileUpload,
  fileUploadAfterSignURL,
  generateMultipleSignUrl,
} from "../../../../actions/emActions";
import Dropzone from "react-dropzone";
import { Progress, Spinner } from "reactstrap";
import $ from "jquery";
import Close from '../../../../public/images/close.png';
import SmileEmoji from '../../../../public/images/Animation - 1720414810921.gif';
import UploadSmileEmoji from '../../../../public/images/Animation - 1720416389083.gif'

const UploadMultipleFeed = (props) => {
  const { programs } = props;
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [text, setText] = useState("");
  const [imageId, setimageId] = useState("");
  const [feedType, setfeedType] = useState();
  const [programInfo, setprogramInfo] = useState("");
  const [worksheetFileData, setworksheetFileData] = useState("");
  const [uploadLoading, setuploadLoading] = useState(false);
  const [openPopup, setopenPopup] = useState(false);
  const [shareFeed, setshareFeed] = useState("private");
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const fileInputRef = useRef(null);

  const handleFileChange = (acceptedFiles) => {
    debugger;
    const newSelectedFiles = [...selectedFiles, ...acceptedFiles];
    setSelectedFiles(newSelectedFiles);

    const newPreviews = acceptedFiles.map((file, index) => ({
      id: index,
      file,
      preview: URL.createObjectURL(file),
      isImage: file.type.startsWith("image/"),
      isVideo: file.type.startsWith("video/"),
    }));
    setPreviews([...previews, ...newPreviews]);
  };
  const handleEditorChange = (content) => {
    setText(content);
    console.log("Editor content:", content); // Log the editor content
  };
  useEffect(() => {
    if (openPopup) {
      $("#uploadconfirmPopup").modal("show");
    }
  }, [openPopup]);

  // console.log("selectedFile", selectedFile);
  console.log("selectedFile", selectedFiles);
  console.log("programInfo", programInfo && JSON.parse(programInfo)?.progid);
  // console.log("programInfo", JSON.parse(programInfo));

  // const uploadFeedFunc = () => {
  //   setuploadLoading(true);
  
  //   if (!selectedFiles || selectedFiles?.length === 0) {

  //     // If no files are selected, just send the text data
  //     const feedData = [{
  //       message: text,
  //       url: null,
  //       url_type: null,
  //     }];
  //     createFeedMultiple(
  //       props.studentId,
  //       JSON.parse(programInfo)?.assignid,
  //       JSON.parse(programInfo)?.course_id,
  //       JSON.parse(programInfo)?.progid,
  //       JSON.parse(programInfo)?.teacher,
  //       JSON.parse(programInfo)?.slot_id,
  //       "student_upload_multiple",
  //       feedData,
  //       shareFeed
  //     ).then((res) => {
  //       window.location.reload();
  //       setuploadLoading(false);
  //     }).catch((err) => {
  //       window.alert("Some Error occurred 1", err);
  //       setuploadLoading(false);
  //     });
  //   } else {
  //     // If files are selected, proceed with file upload
  //     fileUpload(selectedFiles, props?.studentId, "student", (progressEvent) => {
  //       const { loaded, total } = progressEvent;
  //       const percentCompleted = Math.floor((loaded * 100) / total);
  //       setUploadPercentage(percentCompleted);
  //     })
  //       .then((res) => {
  //         if (res?.status === 201) {
  //           const feedData = res?.data.map((item) => {
  //             return {
  //               message: text ?? null,
  //               url: item?.url ?? null,
  //               url_type: item?.filetype ?? null,
  //             };
  //           });
  //           createFeedMultiple(
  //             props.studentId,
  //             JSON.parse(programInfo)?.assignid,
  //             JSON.parse(programInfo)?.course_id,
  //             JSON.parse(programInfo)?.progid,
  //             JSON.parse(programInfo)?.teacher,
  //             JSON.parse(programInfo)?.slot_id,
  //             "student_upload_multiple",
  //             feedData,
  //             shareFeed
  //           ).then((res) => {
  //             window.location.reload();
  //             setuploadLoading(false);
  //           }).catch((err) => {
  //             window.alert("Some Error occurred 2", err);
  //             setuploadLoading(false);
  //           });
  //         } else {
  //           console.log('response',res);
  //           window.alert("Some Error occurred 3");
  //           setuploadLoading(false);
  //         }
  //       })
  //       .catch((err) => {
  //         window.alert("Some Error occurred 4", err);
  //         setuploadLoading(false);
  //       });
  //   }
  // };

  const uploadFeedFunc = () => {
    setuploadLoading(true);
    if (selectedFiles.length > 0) {
      const items = selectedFiles.map((item) => {
        return {
          filename: item?.name,
          fileUserType: "student",
          contentType: item?.type,
          label: "Feeds/student",
          userId: props.studentId,
        };
      });

      let feedData = [];

      console.log('items generateMultipleSignUrl: ', items)
      generateMultipleSignUrl(items)
        .then((res) => {
          console.log('response generateMultipleSignUrl',res);
          if (res?.status === 201) {
            const uploadPromises = res?.data?.map((item, index) => {
              return fileUploadAfterSignURL(
                item?.signurl,
                selectedFiles[index],
                (progressEvent) => {
                  const { loaded, total } = progressEvent;
                  const percentCompleted = Math.floor((loaded * 100) / total);
                  setUploadPercentage(percentCompleted);
                }
              );
            });

            feedData = res?.data.map((item) => {
              return {
                message: text,
                url: item.url,
                url_type: item.filetype,
              };
            });

            // Wait for all uploads to complete
            return Promise.all(uploadPromises);
          }
        })
        .then((uploadResults) => {
          console.log('uploadResults: ', uploadResults);
       
          // Check if all uploads were successful
          const allUploadsSuccessful = uploadResults.every(
            (result) => result.status === 200
          );
         
          if (allUploadsSuccessful) {
            console.log('allUploadsSuccessful: ', allUploadsSuccessful);
          createFeedMultiple(
              props.studentId,
              JSON.parse(programInfo)?.assignid,
              JSON.parse(programInfo)?.course_id,
              JSON.parse(programInfo)?.progid,
              JSON.parse(programInfo)?.teacher,
              JSON.parse(programInfo)?.slot_id,
              "student_upload_multiple",
              feedData,
              shareFeed
            ).then((res) => {
              setuploadLoading(false);
              window.location.reload();
            }).catch((err) => {
              setuploadLoading(false);
              window.alert("Some Error occurred 2", err);
            });
          } else {
            // Handle the case where not all files were uploaded successfully
            console.log("Some files failed to upload.");
            window.alert("Some files failed to upload.");
          }
        })
        .catch((error) => {
          // Handle any errors that occurred during the process
          console.error("Error during file upload:", error);
          window.alert("Error during file upload:");
        })
        .finally(() => {
          setuploadLoading(false);
        });
    } else {
     
      // If no files are selected, just send the text data
      const feedData = [{
        message: text,
        url: null,
        url_type: null,
      }];
      createFeedMultiple(
        props.studentId,
        JSON.parse(programInfo)?.assignid,
        JSON.parse(programInfo)?.course_id,
        JSON.parse(programInfo)?.progid,
        JSON.parse(programInfo)?.teacher,
        JSON.parse(programInfo)?.slot_id,
        "student_upload_multiple",
        feedData,
        shareFeed
      ).then((res) => {
        setuploadLoading(false);
        window.location.reload();
      }).catch((err) => {
        window.alert("Some Error occurred 1", err);
        setuploadLoading(false);
      });
    }
  };



  // remove selected image from images
  const handleRemoveImg = (index) => {
    console.log(`removing the index value is : ${index}`);
    const updatedSelectedFiles = [...selectedFiles];
    updatedSelectedFiles.splice(index, 1);

    const updatedPreviews = [...previews];
    updatedPreviews.splice(index, 1);

    setSelectedFiles(updatedSelectedFiles);
    setPreviews(updatedPreviews);
  };

  return (
    <div className="">
      <div className="card text-left uploadFeed">
        <div className="card-body">
          <div className="d-flex justify-content-between">
            <h5 className="card-title mb-0">
              Upload Photo or Video of your work
            </h5>
          </div>
          <form className="mt-3 row">
            <div className="col-md-12">
              <Dropzone
                accept="image/*, video/*"
                maxFiles={2}
                onDrop={(acceptedFiles) => handleFileChange(acceptedFiles)}
              >
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps({ className: "dropzone" })}>
                    <input {...getInputProps()} />
                    <p>
                      Drag 'n' drop file here, or click to select images/video
                    </p>
                  </div>
                )}
              </Dropzone>
            </div>
            <div className="col-md-12 mt-3">
         <Editor
            apiKey="mppsbn7j0cbtjdkpsffzcdbv6sk6ynge8701axyxfm27bspa"
                initialValue={' '}
                init={{
                height: 200,
                menubar: false,
                plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount',
                'lists'
                        ],
                toolbar:
                'undo redo | formatselect | bold italic | \
                 alignleft aligncenter alignright alignjustify | \
                 bullist numlist outdent indent | removeformat | help',
                 content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                 placeholder: 'Add caption here'
                }}
            onEditorChange={handleEditorChange}
          />
        </div>
            {selectedFiles?.length > 0 && (
              <>
                {previews.map((preview, index) => (
                  <div className="col-md-4 mt-4 col-6" key={preview.preview}>
                    {preview.isImage ? (
                      <div key={index}>
                        <img
                          className="uploadedImg"
                          src={preview.preview}
                          alt={`Preview ${index}`}
                        />
                        <i
                          onClick={() => handleRemoveImg(index)}
                          className="fa fa-times closeIcon"
                        />
                      </div>
                    ) : preview?.isVideo ? (
                      <div key={index}>
                        <video controls width={134} height={134}>
                          <source
                            src={preview?.preview}
                            type={preview?.file.type}
                          />
                          Your browser does not support the video tag.
                        </video>
                        {/* <i className="fa fa-times closeIcon" /> */}
                        <i
                          onClick={() => handleRemoveImg(index)}
                          className="fa fa-times closeIcon"
                        />
                      </div>
                    ) : (
                      <p>Unsupported file type</p>
                    )}
                  </div>
                ))}
              </>
            )}
                   <div className="col-md-12 mt-2">
                  <p className="mb-0">In which course you want to upload?</p>
                  <div className="p-2">
                    {programs?.map((item,index) => (
                      <div key={index}>
                        <input
                          type="radio"
                          onClick={(e) => setprogramInfo(e.target.value)}
                          value={JSON.stringify(item)}
                          checked={
                            programInfo &&
                            JSON.parse(programInfo)?.progid === item?.progid
                          }
                        />
                        <label
                          onClick={() => setprogramInfo(JSON.stringify(item))}
                          className="ml-2"
                        >
                          {item?.prog_name}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
            <div className="col-md-12 mt-3">
              <div className="d-flex justify-content-between">
                <a
                  href="https://lincolnmethod.com/privacy-policy"
                  target="__blank"
                  className="termsServiceText my-auto"
                >
                  See terms of service & GDPR compliance
                </a>
                <button
                  disabled={ 
                    selectedFiles?.length !== 0 && programInfo && !uploadLoading || text !== '' && programInfo && !uploadLoading 
                    ? false : true
          }
                  className="uploadBtn"
                  onClick={(e) => {
                    e.preventDefault();
                    setopenPopup(true);
                  }}
                >
                  {uploadLoading ? <Spinner size="sm" /> : "Upload"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="modalForZoomLink">
        <div
          class="modal fade"
          tabindex="-1"
          role="dialog"
          id="uploadconfirmPopup"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              {uploadLoading ? (
                <div class="modal-body">
                        <div style={{display:'flex', justifyContent:'flex-end'}}>
                      <img style={{width:'15px', height:'15px', cursor:'pointer'}} src={Close} alt='close icon' onClick={() => {
                        setuploadLoading(false);
                      }}/>
                  </div>
                  <div className="text-center">
                    {/* <i className="fas fa-smile fa-4x text-warning"></i> */}
                    <img src={UploadSmileEmoji} alt="smile emoji" style={{width:'70px'}}/>
                    <h5 className="font-weight-bold mt-3">Please Wait...</h5>
                    <div>
                      {/* <Spinner size={"sm"} /> */}
                    <Progress animated bar color="success" className="my-2" value={uploadPercentage}> 
                      {uploadPercentage}%
                    </Progress>
                    </div>
                    <br />
                    <p>
                      {" "}
                      Your content is being uploaded.
                    </p>
                  </div>
                </div>
              ) : (
                <div class="modal-body">
                  <div style={{display:'flex', justifyContent:'flex-end'}}>
                      <img style={{width:'15px', height:'15px', cursor:'pointer'}} src={Close} alt='close icon' onClick={() => {
                        $("#uploadconfirmPopup").modal("hide");
                        setopenPopup(false);
                      }}/>
                  </div>
                  <div className="text-center">
                    {/* <i className="fas fa-smile mr-3 fa-4x text-warning"></i> */}
                    <img src={SmileEmoji} alt="smile emoji" style={{width:'70px'}}/>
                    <h5 className="font-weight-bold mt-3">Ready to post?</h5>
                    <br />
                    <div>
                      <div className="text-left mb-2">
                        <div>
                          <input
                            type="radio"
                            onClick={(e) => setshareFeed(e.target.value)}
                            value="private"
                            checked={shareFeed === "private"}
                          />
                          <label
                            onClick={() => setshareFeed("private")}
                            className="ml-2"
                          >
                            Share with the tutor only
                          </label>
                        </div>
                        <div className="d-flex mb-4">
                          <input
                            className="my-auto"
                            type="radio"
                            onClick={(e) => setshareFeed(e.target.value)}
                            value="public"
                            checked={shareFeed === "public"}
                          />
                          <label
                            onClick={() => setshareFeed("public")}
                            className="my-auto ml-2"
                          >
                             Share with the tutor and other classmates as well
                          </label>
                          <br/><br/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center">
                    <button
                      className="btn btn-success w-20 mx-auto d-block"
                      onClick={() => uploadFeedFunc()}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="text-center mt-3">
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadMultipleFeed;
